import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exclamation from '../../../assets/images/icons/icon-exclamation-circle.svg';
import googleSignIn from '../../../assets/images/google-sign-up-logo.svg';
import msSignIn from '../../../assets/images/ms-sign-up-logo.svg';
import StyledTextField from '../common/StyledTextField';
import PasswordInput from '../PasswordInput';
var SignIn = /*#__PURE__*/function (_Component) {
  function SignIn(props) {
    var _this;
    _classCallCheck(this, SignIn);
    _this = _callSuper(this, SignIn, [props]);
    _this.state = {
      email: '',
      password: '',
      company: props.company || '',
      termsAccepted: false,
      userName: props.userName || '',
      errors: {},
      submitted: false,
      showPasswordField: false
    };
    _this.togglePasswordField = _this.togglePasswordField.bind(_this);
    return _this;
  }
  _inherits(SignIn, _Component);
  return _createClass(SignIn, [{
    key: "togglePasswordField",
    value: function togglePasswordField(e) {
      var showPasswordField = this.state.showPasswordField;
      e.preventDefault();
      this.setState({
        showPasswordField: !showPasswordField
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        error = _this$props.error,
        csrfToken = _this$props.csrfToken,
        passwordError = _this$props.passwordError,
        email = _this$props.email,
        submitUrl = _this$props.submitUrl,
        signUpUrl = _this$props.signUpUrl,
        googleOmniauthUrl = _this$props.googleOmniauthUrl,
        msOmniauthUrl = _this$props.msOmniauthUrl,
        forgotPasswordUrl = _this$props.forgotPasswordUrl,
        recommendationIds = _this$props.recommendationIds,
        appliedToProject = _this$props.appliedToProject,
        sourced = _this$props.sourced,
        conResourceId = _this$props.conResourceId,
        request = _this$props.request,
        location = _this$props.location;
      var showPasswordField = this.state.showPasswordField;
      var emailValue = email || '';
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide card sign-in mx-auto"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header text-center"
      }, "Welcome back!"), error && /*#__PURE__*/React.createElement("div", {
        className: "sign-in-alert body-text-2 text-center"
      }, /*#__PURE__*/React.createElement("img", {
        src: exclamation,
        className: "me-2",
        alt: "error"
      }), error), /*#__PURE__*/React.createElement("form", {
        id: "new_user",
        action: submitUrl,
        method: "post",
        acceptCharset: "UTF-8",
        "data-turbo": "false"
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "authenticity_token",
        value: csrfToken
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "recommendation_ids",
        value: recommendationIds || ''
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "user[applied_to_project]",
        value: appliedToProject || ''
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "user[sourced]",
        value: sourced || ''
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "user[con_resource_id]",
        value: conResourceId || ''
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "user[request]",
        value: request || ''
      }), /*#__PURE__*/React.createElement(StyledTextField, {
        id: "email",
        className: "fs-hide work-email",
        name: "user[email]",
        label: "Email",
        type: "email",
        defaultValue: emailValue,
        required: true,
        autoFocus: true
      }), showPasswordField && /*#__PURE__*/React.createElement(PasswordInput, {
        errors: passwordError,
        title: "Password",
        type: "created"
      }), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, showPasswordField ? /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "btn btn-primary bigger-button full-width"
      }, "Log in") : /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary bigger-button full-width",
        onClick: this.togglePasswordField
      }, "Continue with Email")), showPasswordField && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-text text-center forgot-password"
      }, /*#__PURE__*/React.createElement("a", {
        href: forgotPasswordUrl
      }, "Forgot your password?"))), !showPasswordField && (googleOmniauthUrl || msOmniauthUrl) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "sign-in-divider my-3"
      }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
        className: "or-text"
      }, "or"), /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement("div", {
        className: "sign-in-provider"
      }, googleOmniauthUrl && /*#__PURE__*/React.createElement("a", {
        href: "".concat(googleOmniauthUrl, "?prompt=select_account&state=sign-in"),
        className: "google-sign-in"
      }, /*#__PURE__*/React.createElement("img", {
        src: googleSignIn,
        alt: "Sign in with Google"
      }), /*#__PURE__*/React.createElement("div", {
        className: "sign-in-text"
      }, "Sign in with Google")), msOmniauthUrl && /*#__PURE__*/React.createElement("a", {
        href: "".concat(msOmniauthUrl, "?state=sign-in"),
        className: "ms-sign-in"
      }, /*#__PURE__*/React.createElement("img", {
        src: msSignIn,
        alt: "Sign in with Microsoft"
      }), /*#__PURE__*/React.createElement("div", {
        className: "sign-in-text"
      }, "Sign in with Microsoft")))), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight text-center register-link"
      }, "Don't have a Clora account?\xA0\xA0", /*#__PURE__*/React.createElement("a", {
        className: "employer-registration-to-log-in-".concat(location),
        href: signUpUrl
      }, "Sign Up")));
    }
  }]);
}(Component);
SignIn.propTypes = {
  userName: PropTypes.string,
  error: PropTypes.string,
  passwordError: PropTypes.bool,
  email: PropTypes.string,
  submitUrl: PropTypes.string.isRequired,
  signUpUrl: PropTypes.string.isRequired,
  forgotPasswordUrl: PropTypes.string.isRequired,
  recommendationIds: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  company: PropTypes.string,
  location: PropTypes.string,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  appliedToProject: PropTypes.string,
  sourced: PropTypes.string,
  conResourceId: PropTypes.string,
  request: PropTypes.string
};
SignIn.defaultProps = {
  userName: '',
  email: '',
  error: null,
  passwordError: false,
  company: '',
  location: 'sign-in',
  googleOmniauthUrl: '',
  msOmniauthUrl: '',
  recommendationIds: '',
  appliedToProject: '',
  sourced: '',
  conResourceId: '',
  request: ''
};
export default SignIn;